<template>
	<div>
		<div class="conten">
			<img src="../../../../../../public/img/finish.jpeg" alt="" />
			<div class="but">
				<el-button type="success" @click="success">完成</el-button>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
	computed: {
		...mapGetters(["token", "app_id"]),
	},
	data() {
		return {};
	},
  mounted(){
    
  },
	methods: {
		success() {
			this.$router.push(
				"/apply/newVip/13/market/marketing/client/lottery/index"
			);
		},
	},
};
</script>
<style lang="scss" scoped>
.conten {
	width: 95%;
	height: 20vw;
	background-color: #ffffff;
	margin: 20px auto;
	padding: 20px 0;
	position: relative;
	// line-height: 5vw;
	img {
		width: 8%;
		display: inline-block;
		// margin: 0 auto;
		position: absolute;
		top: 20%;
		left: 50%;
		margin-left: -50px;
	}
	.but {
		position: absolute;
		top: 70%;
		left: 51%;
		margin-left: -50px;
	}
}
</style>
